<template>
  <div class="stat-grid"><slot /></div>
</template>

<script>
export default { name: 'StatGrid' }
</script>

<style scoped>
.stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
}
</style>
